import { render, staticRenderFns } from "./Terms.html?vue&type=template&id=54dd510f&scoped=true&external"
import script from "./Terms.js?vue&type=script&lang=js&external"
export * from "./Terms.js?vue&type=script&lang=js&external"
import style0 from "./Terms.scss?vue&type=style&index=0&id=54dd510f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dd510f",
  null
  
)

/* custom blocks */
import block0 from "./locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2FTerms%2Findex.vue&scoped=true&external"
if (typeof block0 === 'function') block0(component)

export default component.exports